<template>
  <div>
    <h3>'예'라고 응답하신 내용에 대해 좀더 자세히 알려주세요</h3>
    <el-divider></el-divider>

    <div
      class="detail-form"
      v-for="(detail, index) in details"
      :key="index"
    >
      <el-divider v-if="index > 0"></el-divider>
      <h3>상세내역{{ index + 1 }}</h3>

      <el-row>
        <el-col>
          <div class="label mx-0">{{ detail['병명'].label }}</div>
          <el-input
            type="text"
            v-model="detail['병명'].value"
            :placeholder="detail['병명'].placeholder"
            @input="changeDetail(index, '병명')"
          />
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <div class="label mx-0">{{ detail['치료병원'].label }}</div>
          <el-input
            type="text"
            v-model="detail['치료병원'].value"
            :placeholder="detail['치료병원'].placeholder"
            @input="changeDetail(index, '치료병원')"
          />
        </el-col>
      </el-row>

      <el-row :gutter="20" class="my-1">
        <div class="label mx-0">{{ detail['치료기간'].label }}</div>
        <el-col :span="12">
          <el-input
            type="text"
            v-model="detail['치료기간'].value[0].value"
            :placeholder="detail['치료기간'].value[0].placeholder"
            @input="changeDetail(index, '치료기간', 0)"
          >
            <span slot="suffix">부터</span>
          </el-input>
        </el-col>
        <el-col :span="12">          
          <el-input
            type="text"
            v-model="detail['치료기간'].value[1].value"
            :placeholder="detail['치료기간'].value[1].placeholder"
            @input="changeDetail(index, '치료기간', 1)"
          >
            <span slot="suffix">까지</span>
          </el-input>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-input
            type="text"
            v-model="detail['치료기간'].value[2].value"
            :placeholder="detail['치료기간'].value[2].placeholder"
            @input="changeDetail(index, '치료기간', 2)"
          >
            <span slot="suffix">일간</span>
          </el-input>
        </el-col>

        <el-col :span="12">
          <element-select
            :v-model="detail['치료기간'].value[3].value"
            :value="detail['치료기간'].value[3].value"
            :items="detail['치료기간'].value[3].items"
            :placeholder="detail['치료기간'].value[3].placeholder"
            @input="(value) => changeSelectEventHandler(index, '치료기간', 3, value)"
          ></element-select>
        </el-col>
      </el-row>

      <el-row>
        <el-col>
          <div class="label mx-0">{{ detail['치료내용'].label }}</div>
          <el-input
            type="text"
            v-model="detail['치료내용'].value"
            :placeholder="detail['치료내용'].placeholder"
            @input="changeDetail(index, '치료내용')"
          />
        </el-col>
      </el-row>

      <el-row>
        <element-radio
          v-model="detail['재발여부'].value"
          :error="detail['재발여부'].error"
          :label="detail['재발여부'].label"
          :items="detail['재발여부'].items"
          @input="changeDetail(index, '재발여부')"
        />
      </el-row>

      <el-row>
        <element-radio
          v-model="detail['완치여부'].value"
          :error="detail['완치여부'].error"
          :label="detail['완치여부'].label"
          :items="detail['완치여부'].items"
          @input="changeDetail(index, '완치여부')"
        />
      </el-row>
    </div>
    <el-button
      icon="el-icon-plus"
      class="add-detail-btn"
      @click="addDetail"
    >
      상세내역 추가
    </el-button>
  </div>
</template>

<script>
import { Checkbox, Row, Col, Divider, Input, Button, Select } from 'element-ui';

export default {
  components: {
    [Row.name]: Row,
    [Col.name]: Col,
    [Checkbox.name]: Checkbox,
    [Divider.name]: Divider,
    [Input.name]: Input,
    [Button.name]: Button,
    [Select.name]: Select,
  },
  data() {
    return {
      details: [
        {
          '병명': {
            label: "병명",
            value: "",
            error: "",
            placeholder: "증상 및 사고원인 포함",
            validations: [
              { type: "required", message: "필수항목입니다" }
            ]
          },
          '치료병원': {
            label: "치료병원",
            value: "",
            error: "",
            placeholder: "병원명",
            validations: [
              { type: "required", message: "필수항목입니다" }
            ]
          },
          '치료기간': {
            label: "치료기간",
            value: [
              { placeholder: '예:2019.01', value: '' },
              { placeholder: '예:2019.02', value: '' },
              { placeholder: '예:30', value: '' },
              {
                placeholder: '통원/입원 선택',
                value: '',
                items: [
                  { label: '통원', value: '통원' },
                  { label: '입원', value: '입원' },
                ]
              },
            ],
            error: "",
            placeholder: "병원명",
            validations: [
              { type: "required", message: "필수항목입니다" }
            ]
          },
          '치료내용': {
            label: "치료내용",
            value: "",
            error: "",
            placeholder: "치료/수술내용",
            validations: [
              { type: "required", message: "필수항목입니다" }
            ]
          },
          '재발여부': {
            label: "재발여부",
            value: "예",
            error: "",
            validations: [
              { type: "required", message: "필수항목입니다" }
            ],
            items: [
              { label: '예', value: '예' },
              { label: '아니오', value: '아니오' },
            ]
          },
          '완치여부': {
            label: "완치여부",
            value: "예",
            error: "",
            validations: [
              { type: "required", message: "필수항목입니다" }
            ],
            items: [
              { label: '예', value: '예' },
              { label: '아니오', value: '아니오' },
            ]
          },
        }
      ],
    }
  },
  methods: {
    changeDetail(index, key, index2) {
      let data = this.details[index][key];

      if (index2 > -1) {
        const key2 = {
          0: '시작',
          1: '끝',
          2: '일수',
        }[index2];
        data = data.value[index2];

        this.$emit('update-detail-treatment', index, key2, data);
        return;
      }

      this.$emit('update-detail', data, index);
    },
    changeSelectEventHandler(index, key, index2, value) {
      let data = this.details[index][key].value[index2];
      data.value = value;
      
      this.$emit('update-detail-treatment', index, '통입원', data);
    },
    async addDetail() {
      const firstData = this.details[0];
      let detail = {};

      await Object.keys(firstData).map(key => {
        let { value } = firstData[key];
        value = key.indexOf('여부') !== -1 ? '예' : '';

        if (key === '치료기간') {
          value = [
            { placeholder: '예:2019.01', value: '' },
            { placeholder: '예:2019.02', value: '' },
            { placeholder: '예:30', value: '' },
            {
              placeholder: '통원/입원 선택',
              value: '',
              items: [
                { label: '통원', value: '통원' },
                { label: '입원', value: '입원' },
              ]
            },
          ];
        }

        detail[key] = {
          ...firstData[key],
          value
        }
      });

      this.details.push(Object.assign({}, detail));
      this.$emit('add-detail', this.details.length - 1);
    }
  }
}
</script>

<style lang="scss">
  .form-item-list {
    .detail-form {
      h3 {
        margin-bottom: 2*$unit;
      }
      .el-row {
        margin-bottom: 2*$unit;

        &.my-1 {
          margin-bottom: $unit;
        }
        .mx-0 {
          margin-left: 10px;
          margin-right: 10px;
          margin-bottom: $unit;
        }
        .el-input {
          height: 54px;
    
          .el-input__inner {
            height: 54px;
            border-radius: 0;
          }
    
          .el-input__suffix-inner {
            line-height: 54px;
            color: #000;
          }
        }

        .element-select {
          .label {
            display: none;
          }
          .body {
            margin-top: 0;
          }
        }

        .element-radio {
          display: flex;
          justify-content: space-between;

          ul {
            li {
              margin-top: 0 !important;
              padding-right: 2*$unit;

              &::before {
                width: 1.5*$unit;
                height: 1.5*$unit;
              }
              &::after {
                width: 0.8*$unit;
                transform: rotate(-45deg) translateX(0.4rem) translateY(0.2rem);
              }
            }
          }
        }
      }
    }

    .el-button.add-detail-btn {
      border: 1px solid #174BE6;
      height: 48px;
      color: #174BE6;
    }
  }
</style>